import { useQuery } from 'react-apollo';

import { MeWithRootAlbumFolderAlbumsByShootType } from '../../../../../../../../graphql/queries/account';
import { HIERARCHY_SHOOT_TYPE } from '../../../../../../../../constants/shoot-types';
import { albumFolderRequiresNumberedJerseyRecognition } from '../../../helpers';

/**
 * Resolves whether an event performs numbered jersey recognition, and so
 * whether the onboarding form should ask for a jersey number at all.
 *
 * A portrait only event answers on its shoot type alone. A portrait & action
 * event needs its Albums counted -- across every level of the hierarchy, which
 * is why this leans on the account's Albums rather than walking the children.
 *
 * @param {Object} options The options.
 * @param {HIERARCHY_SHOOT_TYPE} options.shootType The event's shoot type.
 * @param {String} options.rootAlbumFolderId The event's root AlbumFolder id.
 * @returns {boolean}
 */
const useNumberedJerseyRecognition = ({ shootType, rootAlbumFolderId }) => {
  const requiresAlbumCheck =
    shootType === HIERARCHY_SHOOT_TYPE.PORTRAIT_AND_ACTION;

  const { data: { me } = {} } = useQuery(
    MeWithRootAlbumFolderAlbumsByShootType,
    {
      variables: {
        id: rootAlbumFolderId,
        shoot_type: HIERARCHY_SHOOT_TYPE.ACTION,
      },
      skip: !requiresAlbumCheck || !rootAlbumFolderId,
    },
  );

  const { albums, albums_by_shoot_type: albumsByShootType } = me ?? {};

  return albumFolderRequiresNumberedJerseyRecognition({
    shootType,
    albumsTotal: albums?.total ?? 0,
    actionAlbumsTotal: albumsByShootType?.total ?? 0,
  });
};

export default useNumberedJerseyRecognition;
